import {
  ChunkEntry,
  DiffInlineRenderProp,
  Line,
  LineAnnotation,
  OnAddComment,
} from '../../common/types';

import { Chunk, SyntaxHighlightedChunk } from './chunk';
import { DiffSide } from './diff-content';

export type ChunkContainerProps = {
  activePermalink?: string;
  chunk: ChunkEntry;
  chunkIndex?: number;
  filePath?: string;
  isSideBySide: boolean;
  inlineContent?: DiffInlineRenderProp;
  onShowMoreLines: (isShiftClicked: boolean, shouldExpandDown: boolean) => void;
  onAddComment?: OnAddComment;
  showPermalinks: boolean;
  onPermalinkClick?: (permalink: string) => void;
  fileAnnotations?: LineAnnotation[];
  isPrAnnotationsEnabled?: boolean;
  isFirstChunk: boolean;
  isLastChunk: boolean;
  isSyntaxHighlightingEnabled?: boolean;
  isMultiChunkExpansionInDiffEnabled?: boolean;
  isDiffSearchEnabled?: boolean;
  shouldHighlightDiffLine?: (diffLine: Line) => boolean;
  getOnSelectionStart?: (
    diffSide: DiffSide
  ) => (chunkIndex: number, lineIndex: number) => void;
  getOnSelectionMove?: (
    diffSide: DiffSide
  ) => (
    chunkIndex: number,
    lineIndex: number,
    currentChunk: ChunkEntry,
    sideBySideChunks?: { before: ChunkEntry; after: ChunkEntry }
  ) => void;
  onSelectionEnd?: () => void;
  shouldHighlightLineDivider?: (line: Line) => boolean;
  isMultilineSelecting?: boolean;
  selectionChunkIndex?: number;
  selectionStartLineIndex?: number;
  shouldShowMLCOnboarding?: boolean;
};

export default function ChunkContainer(
  props: ChunkContainerProps
): JSX.Element {
  const { isSideBySide, isSyntaxHighlightingEnabled, ...commonProps } = props;

  const ChunkComponent = isSyntaxHighlightingEnabled
    ? SyntaxHighlightedChunk
    : Chunk;

  return (
    <div
      className={`chunk-wrapper ${isSideBySide ? 'side-by-side' : ''}`}
      role="rowgroup"
    >
      <ChunkComponent {...commonProps} isSideBySide={isSideBySide} />
    </div>
  );
}
